import {
    SlButton,
    SlSwitch,
    SlTabGroup,
} from "../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace";
import { ReloadManager } from "../cmsmodule/reloadManager";
import { notNull } from "../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";

export class BeratungsManager {
    private readonly beratungTabGroup: SlTabGroup | null;
    private readonly reloadManager: ReloadManager;

    constructor(viewRoot: HTMLElement) {
        this.beratungTabGroup = viewRoot.querySelector(
            ".tariflist-beratung .beratung-tab-group",
        );
        this.reloadManager = new ReloadManager();

        this.initSwitchEvents(viewRoot);
        this.initButtonNoFilter(viewRoot);
        this.initButtonNextStep(viewRoot);
        this.initTabClickEvents(viewRoot);
        this.initButtonClearAllFilter(viewRoot);

        requestAnimationFrame(() => {
            setTimeout(() => {
                this.scrollActiveTabToStart(viewRoot);
            }, 50);
        });
    }

    private scrollActiveTabToStart(viewRoot: HTMLElement): void {
        if (window.innerWidth > 768) {
            return;
        }
        const tabGroup = viewRoot.querySelector(".beratung-tab-group");
        if (!tabGroup) {
            return;
        }
        const activeTab = tabGroup.querySelector(
            "sl-tab[active]",
        ) as HTMLElement;
        if (!activeTab) {
            return;
        }
        const shadowRoot = tabGroup.shadowRoot;
        if (!shadowRoot) {
            return;
        }
        const navPart = shadowRoot.querySelector('[part="nav"]') as HTMLElement;
        if (!navPart) {
            return;
        }
        const nav = navPart.querySelector(".tab-group__nav") as HTMLElement;
        if (!nav) {
            return;
        }

        const tabLeft = activeTab.offsetLeft - 18;
        nav.scrollTo({ left: tabLeft < 0 ? 0 : tabLeft, behavior: "smooth" });
    }

    // netzfilter / junge leute
    private initSwitchEvents(viewRoot: HTMLElement): void {
        const switchElements = viewRoot.querySelectorAll<HTMLElement>(
            ".tariflist-beratung .styled-switch",
        );
        if (switchElements.length === 0) {
            return;
        }

        switchElements.forEach((switchElement) => {
            switchElement.addEventListener("click", (event: Event) => {
                event.preventDefault();
                const fieldId = switchElement.getAttribute("data-fieldid");
                if (!fieldId) {
                    return;
                }
                const input = document.getElementById(
                    fieldId,
                ) as HTMLInputElement;
                const slSwitch = switchElement.querySelector(
                    "sl-switch",
                ) as SlSwitch;
                if (!input || !slSwitch) {
                    return;
                }

                if (switchElement.classList.contains("select-kombi-vorteil")) {
                    this.kombiVorteilOnlyOne(switchElement);
                }

                let newValue = switchElement.getAttribute("data-value");
                if (!newValue) {
                    newValue = input.value === "1" ? "" : "1";
                }
                const text = switchElement.querySelector(
                    ".text",
                ) as HTMLElement;

                if (slSwitch.hasAttribute("checked")) {
                    slSwitch.removeAttribute("checked");
                    slSwitch.checked = false;
                    input.value = "";
                    if (text) {
                        text.innerText = "Nein";
                    }
                } else {
                    slSwitch.setAttribute("checked", "true");
                    slSwitch.checked = true;
                    input.value = newValue;
                    if (text) {
                        text.innerText = "Ja";
                    }
                }

                slSwitch.dispatchEvent(
                    new CustomEvent("sl-change", {
                        bubbles: true,
                        composed: true,
                    }),
                );

                const isSummary = switchElement.closest(".beratung-summary");
                if (!isSummary) {
                    return;
                }

                // wenn wir in der zusammenfassung sind, dann soll das modul direkt neu geladen werden
                const form = switchElement.closest("form") as HTMLFormElement;
                if (form) {
                    const currentStep =
                        form.querySelector<HTMLInputElement>("#currentStep");
                    if (!currentStep) {
                        return;
                    }
                    currentStep.value = "3"; // max step
                    this.reloadManager.reloadModule(form);
                }
            });
        });
    }

    // bei festnetz darf immer nur 1 Festnetz gewaehlt werden, bei klick werden die anderen deaktiviert
    private kombiVorteilOnlyOne(currentSwitchElement: HTMLElement) {
        const allSwitcherFromFromKombiVorteil = notNull(
            currentSwitchElement.closest(".filter-selections"),
        ).querySelectorAll<SlSwitch>(".select-kombi-vorteil sl-switch");
        allSwitcherFromFromKombiVorteil.forEach((element) => {
            const idSwitch = notNull(
                element.closest(".select-kombi-vorteil"),
            ).getAttribute("id");
            const currentIdSwitch = notNull(
                currentSwitchElement.closest(".select-kombi-vorteil"),
            ).getAttribute("id");

            // nur wenn es nicht das aktuelle ist, soll es deaktiviert werden
            if (idSwitch === currentIdSwitch) {
                return;
            }

            element.checked = false;
            element.dispatchEvent(
                new CustomEvent("sl-change", {
                    bubbles: true,
                    composed: true,
                }),
            );
        });
    }

    // button "weiter" => form submit
    private initButtonNextStep(viewRoot: HTMLElement): void {
        const nextStepButtons = viewRoot.querySelectorAll<SlButton>(
            ".tariflist-beratung .next-step",
        );
        if (nextStepButtons.length === 0) {
            return;
        }

        nextStepButtons.forEach((button) => {
            button.addEventListener("click", (event: Event) => {
                event.preventDefault();

                const form = button.closest("form") as HTMLFormElement;
                if (form) {
                    this.reloadManager.reloadModule(form);
                    event.stopImmediatePropagation();
                }
            });
        });
    }

    // button "weiter ohne Angabe" => bereits gewaehle felder leeren
    private initButtonNoFilter(viewRoot: HTMLElement): void {
        const noFilterButtons = viewRoot.querySelectorAll<SlButton>(
            ".tariflist-beratung .no-filter",
        );
        if (noFilterButtons.length === 0) {
            return;
        }

        noFilterButtons.forEach((button) => {
            button.addEventListener("click", (event: Event) => {
                event.preventDefault();

                const tabPanel = button.closest("sl-tab-panel");
                if (tabPanel) {
                    // Alle Eingabefelder innerhalb des Tab-Panels zuruecksetzen
                    const inputs =
                        tabPanel.querySelectorAll<HTMLInputElement>("input");
                    inputs.forEach((input) => {
                        input.value = "";
                    });
                }
                const form = button.closest("form") as HTMLFormElement;
                if (form) {
                    this.reloadManager.reloadModule(form);
                    event.stopImmediatePropagation();
                }
            });
        });
    }

    // wenn man auf einen tab klickt, soll da modul abgeschickt werden, nachdem der currentstep gesetzt wurde
    private initTabClickEvents(viewRoot: HTMLElement): void {
        const beratungTabs = viewRoot.querySelectorAll<HTMLElement>(
            ".beratung-tab-group sl-tab",
        );
        if (beratungTabs.length === 0) {
            return;
        }

        beratungTabs.forEach((consultingTab) => {
            consultingTab.addEventListener("click", (event: Event) => {
                event.preventDefault();
                this.scrollActiveTabToStart(viewRoot);
                const form = consultingTab.closest("form") as HTMLFormElement;
                if (!form) {
                    return;
                }
                // aktuellen step setzen, damit man wenn man auf die tabs klickt und dann weiter klickt auch im naechsten step landet
                const currentStep =
                    form.querySelector<HTMLInputElement>("#currentStep");
                if (!currentStep) {
                    return;
                }
                const stepValue =
                    parseInt(consultingTab.dataset.step || "0", 10) - 1;
                currentStep.value = stepValue.toString();
                this.reloadManager.reloadModule(form);
            });
        });
    }

    private initButtonClearAllFilter(viewRoot: HTMLElement): void {
        const clearAllFilterButtons = viewRoot.querySelectorAll<HTMLElement>(
            ".clearBeratungsFilter, .nulltreffer-filter",
        );
        if (clearAllFilterButtons.length === 0) {
            return;
        }

        clearAllFilterButtons.forEach((button) => {
            button.addEventListener("click", (event: Event) => {
                event.preventDefault();

                let form = button.closest("form") as HTMLFormElement;
                // Falls kein umschliessendes Formular gefunden wurde, das Formular innerhalb des CMS-Moduls suchen
                // in dem fall sind wir in der liste - nulltreffer bereich
                if (!form) {
                    const moduleRoot = button.closest(".cms-module-root");
                    let form = moduleRoot?.querySelector(
                        "form",
                    ) as HTMLFormElement;
                    if (!form) {
                        return;
                    }
                }
                // `clearBeratungsFilter`-Feld auf `1` setzen, um Filter zu leeren
                const clearFilterField = form.querySelector<HTMLInputElement>(
                    '[name="clearBeratungsFilter"]',
                );
                if (clearFilterField) {
                    clearFilterField.value = "1";
                }
                this.reloadManager.reloadModule(form);
            });
        });
    }
}
